<section class="mortgage-calculator">
  <header>
    <h4 translate="mortgage-calculator.title"></h4>
    <img class="pull-right td-logo" alt="TD logo" src="{{'/assets/icons/td-logo.png' | staticp }}" />
  </header>
  <div class="bordered mortgage-payment-amount">
    <p class="info" translate="mortgage-calculator.your-mortgage-payment"></p>
    <div class="mortgage-calculator__monthly-amount">
      <span class="payment-amount">{{mortgagePaymentAmount}}</span>
      <span class="has-pos-rel frequency">/ {{paymentFrequencyText}} *</span>
    </div>
  </div>
  <div class="bordered--redesign">
    <span class="toggle-sections" (click)="showMoreSection=!showMoreSection" role="button" tabindex="0" (keydown.enter)="showMoreSection=!showMoreSection">
      {{ (showMoreSection ? 'mortgage-calculator.hide-details' : 'mortgage-calculator.how-calculated') | translate }}
      <i class="material-icons">{{ showMoreSection ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </span>
  </div>
  <div class="show-more-section" [class.collapsed]="!showMoreSection">
    <div class="bordered--redesign">
      <form (ngSubmit)="onSubmit()" [formGroup]="mortgageForm">
        <app-input [label]="'mortgage-calculator.mortgage-amount' | translate "
        [formControl]="mortgageForm.get('mortgageAmount')" [parentFormGroup]="mortgageForm"
          inputId="mortgageAmount" [isFullWidth]="true" pattern="[0-9]+">
        </app-input>
        <app-select [label]="'mortgage-calculator.payment-frequency' | translate "[formControl]="mortgageForm.get('paymentFrequency')" [parentFormGroup]="mortgageForm"
        [options]="frequencyOptions" inputId="paymentFrequency"></app-select>
        <ng-container *ngIf="showCustomRate">
          <app-input [isFullWidth]="showCustomRate" [label]="'mortgage-calculator.interest-amount' | translate"
          [formControl]="mortgageForm.get('customRate')" [parentFormGroup]="mortgageForm"
            pattern="[0-9.]+" inputId="customRate"></app-input>
          <a (click)="toggleCustomRate()" translate="mortgage-calculator.pick-defined-rate"></a>
        </ng-container>
        <ng-container *ngIf="!showCustomRate">
          <app-select [label]="'mortgage-calculator.interest-rate' | translate " [options]="rateOptions"
          inputId="mortgageRate" [formControl]="mortgageForm.get('mortgageRate')" [parentFormGroup]="mortgageForm"></app-select>
          <a (click)="toggleCustomRate()" translate="mortgage-calculator.enter-own-rate"></a>
        </ng-container>
        <app-input  [label]="'mortgage-calculator.amortization-period' | translate " [formControl]="mortgageForm.get('amortizationPeriod')" [parentFormGroup]="mortgageForm"
          inputId="amortizationPeriod" [isFullWidth]="true" inputType="number" pattern="[0-9]+">
        </app-input>
        <button type="submit" [disabled]="!mortgageForm.valid" role="button" class="btn-redesign btn-redesign--primary btn-redesign--max-size-440 btn-redesign--center-button mortgage-calculator__submit-button" translate="mortgage-calculator.recalculate"
          angulartics2On="click" [angularticsProperties]="{ event: 'residential_use_mortgage_calculator' }"
        ></button>
        <aside>
          <p translate="mortgage-calculator.demonstration-only"></p>
        </aside>
      </form>
      <div class="mortgage-calculator__get-more-info-container">
        <h4 translate="mortgage-calculator.get-more-info"></h4>
        <img class="pull-right td-logo" alt="TD logo" src="{{'/assets/icons/td-logo.png' | staticp }}" />
      </div>

    </div>
    <footer style="padding: 5%;">
      <ul class="mortgage-links">
        <li>
          <a href="https://tools.td.com/HMCIA/" target="blank">
            <span></span>{{ 'mortgage-calculator.how-much-afford' | translate }}</a>
        </li>
        <li>
          <a href="https://www.tdcanadatrust.com/webforms/mobmortgage.form?lang=en" target="blank">
            <span></span>{{ 'mortgage-calculator.ready-to-apply' | translate }}</a>
        </li>
        <li>
          <a href="https://tools.td.com/WMWFM/" target="blank">
            <span></span>{{ 'mortgage-calculator.which-mortgage-works' | translate }}</a>
        </li>
        <li>
          <a href="http://mms.tdcanadatrust.com/locator_mms/" target="blank">
            <span></span>{{ 'mortgage-calculator.mobile-mortgage' | translate }}</a>
        </li>
      </ul>
    </footer>
  </div>
</section>
<article class="mortgage-ad">
  <ng-content></ng-content>
</article>
